import React from 'react';
import { Clock, DollarSign, ArrowRight } from 'lucide-react';

const AcceleratorCard = ({ accelerator, onClick }) => {
  return (
    <div 
      className="bg-white rounded-xl shadow-lg p-6 card-hover cursor-pointer h-full flex flex-col"
      onClick={() => onClick(accelerator)}
    >
      {/* Header: Title and Category */}
      <div className="flex items-start justify-between mb-3">
        <h3 className="text-xl font-semibold text-gray-900 flex-1 mr-4">{accelerator.name}</h3>
        <div className="flex-shrink-0">
          <div className="bg-primary-100 text-primary-800 px-3 py-1 rounded-full text-xs font-medium">
            {accelerator.category_name}
          </div>
        </div>
      </div>

      {/* Description - Full Width */}
      <div className="mb-4">
        <p className="text-gray-600 text-sm line-clamp-2 leading-relaxed">{accelerator.description}</p>
      </div>

      {/* Delivery Time - Compact */}
      <div className="flex items-center mb-4 text-sm text-gray-500">
        <div className="flex items-center space-x-1">
          <Clock className="h-4 w-4" />
          <span>{accelerator.delivery_time}</span>
        </div>
        {/* Pricing temporarily hidden */}
        {/* <div className="flex items-center space-x-1 text-green-600 font-semibold">
          <span>Starting at ${accelerator.pricing_amount}/{accelerator.pricing_model?.replace('_', ' ')}</span>
        </div> */}
      </div>

      {/* Features Preview - Horizontal */}
      <div className="flex flex-wrap gap-2 mb-4">
        {accelerator.features?.slice(0, 3).map((feature, index) => (
          <span key={index} className="bg-blue-100 text-blue-700 px-2 py-1 rounded text-xs font-medium">
            {feature}
          </span>
        ))}
        {accelerator.features?.length > 3 && (
          <span className="bg-gray-100 text-gray-600 px-2 py-1 rounded text-xs">
            +{accelerator.features.length - 3} more
          </span>
        )}
      </div>

      {/* Target Tech Stacks - Compact */}
      <div className="mb-4">
        <div className="text-xs font-medium text-gray-700 mb-2">Compatible with:</div>
        <div className="flex flex-wrap gap-1">
          {accelerator.target_techstack?.slice(0, 4).map((techstack, index) => (
            <span key={index} className="bg-green-100 text-green-700 px-2 py-1 rounded-full text-xs">
              {techstack.display_name || techstack.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())}
            </span>
          ))}
          {accelerator.target_techstack?.length > 4 && (
            <span className="bg-gray-100 text-gray-600 px-2 py-1 rounded-full text-xs">
              +{accelerator.target_techstack.length - 4}
            </span>
          )}
        </div>
      </div>

      {/* CTA Button */}
      <div className="mt-auto">
        <button className="w-full bg-primary-600 text-white py-3 px-4 rounded-lg hover:bg-primary-700 transition-colors flex items-center justify-center space-x-2 font-medium">
          <span>View Details</span>
          <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

export default AcceleratorCard;